





































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DurasiJamMenit from "./DurasiJamMenit.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { hmToDate, dateToHm } from "@/utility/PartografHelper";

@Component({ components: { DurasiJamMenit, VCDateTimePicker } })
export default class SectionKala3 extends Vue {
  @Prop({ required: true }) value!: any;
  local: any = {};

  get jamPlasenta() {
    return hmToDate(this.local.plasenta_lahir_jam);
  }

  setJamPlasenta(val: any) {
    this.$set(this.local, "plasenta_lahir_jam", dateToHm(val));
  }

  @Watch("value", { immediate: true, deep: true })
  onValueChange(v: any) {
    const vStr = JSON.stringify(v || {});
    if (JSON.stringify(this.local) === vStr) return;
    this.local = JSON.parse(vStr);
    if (!this.local.atonia_uteri) {
      this.local.atonia_uteri = { kompresi_bimanual: false, metil_ergometrin: false, oksitosin_drip: false };
    }
    if (!Array.isArray(this.local.plasenta_tidak_lengkap_tindakan) || this.local.plasenta_tidak_lengkap_tindakan.length < 2) {
      this.local.plasenta_tidak_lengkap_tindakan = ["", ""];
    }
    if (!Array.isArray(this.local.plasenta_tidak_lahir_tindakan) || this.local.plasenta_tidak_lahir_tindakan.length < 3) {
      this.local.plasenta_tidak_lahir_tindakan = ["", "", ""];
    }
    if (!Array.isArray(this.local.atonia_tindakan) || this.local.atonia_tindakan.length < 3) {
      this.local.atonia_tindakan = ["", "", ""];
    }
  }

  @Watch("local", { deep: true })
  emitInput(v: any) {
    this.$emit("input", v);
  }
}
